module.exports = __webpack_public_path__ + "img/undraw_collaborating_re_l43g.ae7dbedf.svg";